// Names the backend gives a new account's starter group, site and sample location (PWA-3010).
// Starter items are recognised by these names alone, so there is no stored flag to keep in sync.
export const STARTER_GROUP_NAME = 'My sites';
export const STARTER_SITE_NAME = 'My first site';
export const STARTER_LOCATION_NAME = 'Sample location 1';

export const isDefaultSiteName = (name?: string) => name?.trim() === STARTER_SITE_NAME;

export const isDefaultLocationName = (name?: string) => name?.trim() === STARTER_LOCATION_NAME;

// Fired by a site card to open Sites & Groups, which lives in the main menu's admin dialog.
export const OPEN_SITES_AND_GROUPS_EVENT = 'relay:open-sites-and-groups';

const dismissKey = (userKey: string, siteId: number) => `starterPanelDismissed:${userKey}:${siteId}`;

export const isStarterPanelDismissed = (userKey: string, siteId: number) => {
	try {
		return localStorage.getItem(dismissKey(userKey, siteId)) === 'true';
	} catch {
		return false;
	}
};

export const dismissStarterPanel = (userKey: string, siteId: number) => {
	try {
		localStorage.setItem(dismissKey(userKey, siteId), 'true');
	} catch {
		// Storage can be unavailable (private mode); the panel then just shows again next visit.
	}
};
